/**
 * @desc 分页
 */
const URL = "/rantion-esca";
import http, { updateResponse } from "@/http";
export function request(
  body: defs.esca.EApiRecordRequestParamsDto,
  params: API.esca.eApiRecord.page.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/eApiRecord/page`, {
      method: "POST",
      params,
      data: body,
      ...options,
    }),
  );
}
